export const DATE_RANGE_PRESETS = [
  { value: "7d", label: "7 Days", days: 7 },
  { value: "30d", label: "30 Days", days: 30 },
  { value: "3m", label: "3 Months", days: 90 },
  { value: "6m", label: "6 Months", days: 180 },
  { value: "12m", label: "12 Months", days: 365 },
] as const;

export type DateRangePreset = (typeof DATE_RANGE_PRESETS)[number]["value"];

export const DEFAULT_DATE_RANGE_PRESET: DateRangePreset = "12m";
export const DEFAULT_MAX_RESULTS = 50;
export const MIN_MAX_RESULTS = 10;
export const MAX_MAX_RESULTS = 200;
